export const GET_BANKACCOUNT = `/api/v1/user/get/bank/account`;
export const ADD_BANKACCOUNT = `/api/v1/user/bank/account/add`;
export const UPDATE_BANKACCOUNT = `/api/v1/user/card/update`;
export const ADD_SHEBA = `/api/v1/user/bank/account/iban/create`;
export const UPDATE_SHEBA = `/api/v1/user/iban/update`;
